require([
    "ProductOptions/productOptions"
],
function (productOptions) {

    productOptions.init();
    window.Coria = window.Coria || {};
    window.Coria.reInitProductOptions = productOptions.init;
});

define("ProductOptions/main", function(){});

